// Registers Prism-based syntax highlighting for CodeNode blocks.
// Uses @lexical/code's built-in PrismTokenizer which maps token types
// to the codeHighlight theme classes (VS Code Dark+ palette).

import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { registerCodeHighlighting } from '@lexical/code';

export default function CodeHighlightPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return registerCodeHighlighting(editor);
  }, [editor]);

  return null;
}
